<template>
    <div class="row">
        <div v-for="(product, index) in products" class="col-lg-2 col-md-3 col-sm-6 col-xs-12">
            <div class="thumbnail">
                <template v-if="product.images.length">
                    <a :href="`/shop/${product.id}`">
                        <img :src="product.images[0].thumb_url" :alt="product.images[0].filename" class="product-image img-thumbnail" width="180" height="180">
                    </a>
                </template>
                <template v-if="product.images.length == 0">
                    <a :href="`/shop/${product.id}`">
                        <div class="product-image-empty text-center img-responsive">&nbsp;
                        </div>
                    </a>
                </template>
                <div class="caption">
                    <h4>{{ product.name }}</h4>
    
                    <div class="row">
                        <h5 class="col-sm-12">{{ product.price | currency }}</h5>
                    </div>
                    <div class="row">
                        <p class="col-sm-12">
                            <button @click="add(product)" v-if="!requiresOptions(product)" class="btn btn-primary btn-block btn-md">Add to Basket</button>
                            <a :href="`/shop/${product.id}`" v-if="requiresOptions(product)" class="btn btn-primary btn-block btn-md">Select Options</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <vuedal></vuedal>
    </div>
</template>
<script>
    import Vue from 'vue';
    import { mapActions } from 'vuex';
    import { default as Vuedals, Component as Vuedal, Bus as VuedalsBus } from 'vuedals';

    Vue.use(Vuedals);

    export default {
        components: {
            Vuedal
        },

        data: function () {
            return {
                products: []
            };
        },

        mounted() {
            this.getProducts();
        },

        methods: {
            getProducts() {
                axios.get('/api/v1/products').then((response) => {
                    this.products = response.data.map(function (product) {
                        product.variantsDisplay = false;
                        product.selectedVariants = [];

                        return product;
                    });
                }).catch((error) => {
                    this.$message({message: 'There was a problem loading club products.', type: 'error'});
                });
            },

            add(product) {
                if (this.productVariants(product).length != product.selectedVariants.length) {
                    this.$message({message: 'You have to choose product variants.', type: 'error'});
                    return false;
                }

                this.addToCart(product);
                product.selectedVariants = [];
            },

            requiresOptions(product) {
                return product.variants.length || product.personalised;
            },

            productVariants(product) {
                let variantTypes = _.map(_.uniqBy(product.variants, function (variant) {
                    return variant.label;
                }), (variantType) => {
                    return { label: variantType.label };
                });

                for (let variantType of variantTypes) {
                    variantType.variants = _.filter(product.variants, ['label', variantType.label]);
                }

                return variantTypes;
            },

            ...mapActions({
                addToCart: 'cart/addToCart'
            })
        }
    }
</script>

<style>
    .vuedal img {
        max-width: 100%;
        height: auto;
    }
    .product-image {
        width: 180px!important;
        height: 180px!important;
    }
    .product-image-empty {
        width: 180px!important;
        height: 180px!important;
        background-color: #ccc;
        margin-left: auto;
        margin-right: auto;
    }
</style>
